export enum EnumAmbientePagamento {
    Sandbox = 0,
    Homologacao = 1,
    Producao = 2
}